import { useState } from 'react';

const useForm = (formState, callback) => {

  const [formData, setFormData] = useState({...formState});
  const [lastEvent, setLastEvent] = useState({});
  const [stateForm, setStateForm] = useState({});

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
    setLastEvent({[name]: value})
  };

  const onSubmitForm = (e) => {
    e.preventDefault();
    callback();
  };

  const watch = () => {
    if(!Object.keys(lastEvent).length) {
      return false;
    };

    const key = Object.keys(lastEvent)[0];
    const value = lastEvent[key];
    const oldKey = Object.keys(stateForm)[0];
    const oldValue = stateForm[oldKey];

    if(key === oldKey && oldValue === value) {
      return false;
    };

    setStateForm(lastEvent);

    return lastEvent;
  };

  return {
    watch,
    formData,
    onChangeInput,
    onSubmitForm,
    setFormData: newFormData => setFormData({...newFormData}),
  };
};

export default useForm;
